import type { Ref } from 'vue';
import { ref } from 'vue';

interface UserData {
  email: string;
  password: string;
}

const objectRef: Ref<UserData> = ref({ email: "", password: "" });

export function useHoldData() {

  function setObject(object: UserData) {
    objectRef.value = object;
  }

  function getObject(): UserData {
    setDeleteData()
    return objectRef.value;
  }

  function checkData(): boolean {
    if (objectRef.value.email !== "" && objectRef.value.password !== "") {
      return true;
    }
    return false;
  }

  function clearObject() {
    objectRef.value = { email: "", password: "" };
  }

  function setDeleteData() {
    setTimeout(clearObject, 5 * 60 * 1000);
  }

  return {
    setObject,
    getObject,
    checkData,
    clearObject,
  };
}
